import axios from 'axios';
import * as Sentry from '@sentry/react';

export const sendReassignmentConfirmation = data =>
	axios.post('/forms_rest_api/email', data).catch(Sentry.captureException);

export const emailDriverExemptions = (uid, driver_exemptions, project_number) =>
	axios
		.post('/forms_rest_api/driver_exemption', {
			uid,
			driver_exemptions,
			project_number
		})
		.catch(Sentry.captureException);
